import React from 'react'
import { Display2, Display4 } from '@sainsburys-tech/fable'
import { PropTypes } from 'prop-types'


const TitleComponent = (props) => {
  const { workOrderNumber, text } = props
  return (
    <div className="dsib-assessmentStatements__header">
      <Display2 className="dsib-assessmentStatements__workOrder">
        Work order:
        {workOrderNumber}
      </Display2>
      <Display4 className="dsib-assessmentStatements__title">{text}</Display4>
    </div>
  )
}

TitleComponent.propTypes = {
  text: PropTypes.string.isRequired,
  workOrderNumber: PropTypes.string.isRequired
}

export default TitleComponent
